var winWidth = $(window).width();
var pageTitle = $(document).find('title').text();
$(document).ready(() => {
  init();
  tray();
  accordions();
  postsAjax();
  careers();
  tabs();
  tabsResize();
  plyrVideos();
  counters();
});


$(window).on('resize', () => {
  winWidth = $(window).width();
  tabsResize();
});

function init() {
  // Setup WOW animations
  let wow = new WOW({
    boxClass: 'wow',
    animateClass: 'animated',
    offset: 0,
    mobile: true,
    live: true,
  });
  wow.init();

  // Remove all '<br />' tags from CF7
  $('.wpcf7').find('br').remove();
}
function tray() {
  $('.header .hamburger').on('click', function () {
    if ($('body').hasClass('navOpen')) {
      $('html').css('overflow', '');
    } else {
      $('html').css('overflow', 'hidden');
    }

    if ($(window).width() > 768) {
      $('.tray').toggleClass('tray--open');
    } else {
      $('.tray').fadeToggle(300);
    }
    $('body').toggleClass('navOpen');
    $(this).toggleClass('hamburger--toggled');
  });


  $('.tray ul li.menu-item-has-children > a').on('click', function (e) {
    e.preventDefault();
    $(this).parent().find('.sub-menu').slideToggle(300);
  });

}

function accordions() {
  $('.accordions__accordion button.toggle-accordion').on('click', function () {
    var thisAccordion = $(this).parents('.accordions__accordion');
    thisAccordion.toggleClass('accordions__accordion--open');
  });

  if ($(window).width() < 992) {
    $('.accordions__accordion__preview__content p').each(function () {
      var originalContent = $(this).text();
      $(this).text(originalContent.substring(0, 100) + '...');
    });
  }
}

function counters() {
  $('.counter').each(function () {
    var self = this
    var $div = $(this).parents('.wow');
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        const operand = $(self).data("operand")
        $(self).prop('Counter', 0).animate({
          Counter: $(self).attr('data-number'),
        }, {
          duration: $(self).attr('data-counter-speed') ? $(self).attr('data-counter-speed') : 2000,
          easing: 'swing',
          step: function (now) {
            $(self).text(Math.ceil(now));
          },
          complete: function () {
            $(self).append(operand)
          }
        });
      });
    });

    observer.observe($div[0], {
      attributes: true,
      attributeFilter: ['class']
    });
  });
}

function postsAjax() {
  var currentPage = 2;
  $('.flexible-section.posts .load-more button').on('click', function (e) {
    e.preventDefault();
    $.ajax({
      url: $(this).attr('data-url'),
      type: 'post',
      data: {
        paged: currentPage,
        nonce: $(this).attr('data-nonce'),
        action: 'ngen_load_more_posts'
      },
      beforeSend: function () {
        $('.flexible-section.posts .load-more button').attr('disabled', true);
      },
      success: function (response) {
        response = JSON.parse(response);
        if (response.posts) {
          $.each(response.posts, function (index, post) {
            $('.flexible-section.posts .posts__grid').append(post);
          });
        }
        currentPage++;
        if (!response.can_load_more) {
          $('.flexible-section.posts .load-more button').attr('disabled', true).remove();
        } else {
          $('.flexible-section.posts .load-more button').removeAttr('disabled');
        }
      }
    })
  });
}

function careers() {
  $('.careers__accordions .careers__career > button, .careers__accordions .careers__career .careers__career__title').on('click', function () {
    var thisCareer = $(this).parents('.careers__career');
    thisCareer.find('button i').toggleClass('fa-plus fa-minus');
    thisCareer.find('.careers__career__title').toggleClass('careers__career__title--expanded')
    thisCareer.find('.careers__career__content').slideToggle(300);
  });

  if ($('body').hasClass('single-vacancies')) {
    $('input[name="job_title"]').val(pageTitle);
  }
}

function tabs() {
  $('.flexible-section.tabs a.nav-link').on('click', function () {
    var link = $(this).attr('href');
    if (link.includes('http')) {
      window.location = link;
    }
  });
}

function tabsResize() {
  if ($('.flexible-section.tabs').length) {
    $('.flexible-section.tabs a.nav-link').each(function () {
      var uid = $(this).attr('data-uid');
      var link = $(this).attr('data-link');
      var href = $(this).attr('href');

      if (winWidth > 768) {
        $(this).attr('href', uid);
      } else {
        $(this).attr('href', link);
      }
    });
  }
}

function plyrVideos() {
  const plyr = new Plyr('.plyr');
}